/* Mobile menu */
(function () {
    const nav = document.querySelector('.fa-nav');
    const burger = nav && nav.querySelector('.fa-burger');
    if (!burger) return;

    function setOpen(open) {
        if (open) nav.style.setProperty('--fa-nav-bottom', nav.getBoundingClientRect().bottom - 1 + 'px'); // -1: the panel starts inside the nav's bottom border
        nav.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open);
        document.documentElement.classList.toggle('fa-menu-open', open);
    }

    burger.addEventListener('click', function () {
        setOpen(!nav.classList.contains('is-open'));
    });

    nav.querySelector('.fa-nav-menu').addEventListener('click', function (e) {
        if (e.target.closest('a')) setOpen(false);
    });

    window.matchMedia('(min-width: 900px)').addEventListener('change', function (e) {
        if (e.matches) setOpen(false);
    });
})();

/* Homepage lead carousel. A slide advances when its progress bar's fill animation ends,
   so pausing (hover, keyboard focus, hidden tab, scrolled away) is just pausing that animation.
   Reduced motion: animations are off globally, so it never auto-advances and switches instantly. */
(function () {
    const carousel = document.querySelector('.fa-carousel');
    const slides = carousel ? carousel.querySelectorAll('.fa-slide') : [];
    if (slides.length < 2) return;

    const controls = carousel.querySelector('.fa-carousel-controls');
    const barsWrap = carousel.querySelector('.fa-carousel-bars');
    const now = carousel.querySelector('.fa-carousel-now');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pad = function (n) { return String(n).padStart(2, '0'); };
    const LEAVE_MS = 700; // longest exit: the image cross-fade
    let current = 0;
    const timers = new WeakMap();

    carousel.style.setProperty('--fa-interval', (parseInt(carousel.dataset.interval, 10) || 5000) + 'ms');
    carousel.querySelector('.fa-carousel-total').textContent = pad(slides.length);

    const bars = Array.prototype.map.call(slides, function (slide, i) {
        slide.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
        const bar = document.createElement('button');
        bar.type = 'button';
        bar.className = 'fa-carousel-bar';
        bar.setAttribute('aria-label', 'Show story ' + (i + 1));
        bar.appendChild(document.createElement('span'));
        bar.addEventListener('click', function () { show(i); });
        bar.firstChild.addEventListener('animationend', function () { if (i === current) show((i + 1) % slides.length); });
        barsWrap.appendChild(bar);
        return bar;
    });
    controls.hidden = false;

    function show(i, initial) {
        if (i === current && !initial) return;
        const prev = slides[current];
        if (!initial) {
            prev.classList.remove('is-active', 'is-entering');
            prev.inert = true;
            if (!reduceMotion.matches) {
                prev.classList.add('is-leaving');
                clearTimeout(timers.get(prev));
                timers.set(prev, setTimeout(function () { prev.classList.remove('is-leaving'); }, LEAVE_MS));
            }
        }

        current = i;
        const next = slides[i];
        clearTimeout(timers.get(next));
        next.classList.remove('is-leaving');
        next.inert = false;
        next.classList.add('is-active');
        if (!initial) {
            next.classList.remove('is-entering');
            void next.offsetWidth; // restart the entry animations if this slide is re-entered quickly
            next.classList.add('is-entering');
        }

        bars.forEach(function (bar, n) {
            bar.classList.toggle('is-done', n < i);
            bar.classList.remove('is-active');
            bar.removeAttribute('aria-current');
        });
        void bars[i].offsetWidth; // restart the fill from zero
        bars[i].classList.add('is-active');
        bars[i].setAttribute('aria-current', 'true');
        now.textContent = pad(i + 1);
    }
    show(0, true);

    const step = function (d) { show((current + d + slides.length) % slides.length); };
    carousel.querySelector('.fa-carousel-arrow.is-prev').addEventListener('click', function () { step(-1); });
    carousel.querySelector('.fa-carousel-arrow:not(.is-prev)').addEventListener('click', function () { step(1); });
    carousel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') step(-1);
        if (e.key === 'ArrowRight') step(1);
    });

    let hovered = false, focused = false, offscreen = false;
    function update() {
        carousel.classList.toggle('is-paused', hovered || focused || offscreen || document.hidden);
    }
    carousel.addEventListener('mouseenter', function () { hovered = true; update(); });
    carousel.addEventListener('mouseleave', function () { hovered = false; update(); });
    // Only keyboard focus pauses; a tapped button keeps focus and would otherwise stop rotation on phones
    carousel.addEventListener('focusin', function (e) { focused = e.target.matches(':focus-visible'); update(); });
    carousel.addEventListener('focusout', function (e) { focused = carousel.contains(e.relatedTarget) && focused; update(); });
    document.addEventListener('visibilitychange', update);
    new IntersectionObserver(function (entries) {
        offscreen = !entries[0].isIntersecting;
        update();
    }, {threshold: 0.35}).observe(carousel);

    let touchX = null, touchY = null;
    carousel.addEventListener('touchstart', function (e) {
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
    }, {passive: true});
    carousel.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        const dx = e.changedTouches[0].clientX - touchX;
        const dy = e.changedTouches[0].clientY - touchY;
        touchX = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    });
})();

/* UTM tags on every outbound link (theme links and links inside posts).
   utm_source = this blog's host, utm_medium = blog, utm_campaign = page slug,
   utm_content = placement from the nearest [data-utm] (else "content" / "link").
   Existing utm_* values on a link are kept; [data-utm-skip] opts a link out. */
(function () {
    const slug = location.pathname.split('/').filter(Boolean).pop() || 'home';

    function tag(a) {
        if (a.dataset.utmDone !== undefined || a.closest('[data-utm-skip]')) return;
        let url;
        try { url = new URL(a.href); } catch (e) { return; }
        if (!/^https?:$/.test(url.protocol) || url.hostname === location.hostname) return;

        const placement = a.closest('[data-utm]');
        const params = {
            utm_source: location.hostname,
            utm_medium: 'blog',
            utm_campaign: slug,
            utm_content: placement ? placement.dataset.utm : (a.closest('.gh-content') ? 'content' : 'link'),
        };
        Object.keys(params).forEach(function (key) {
            if (!url.searchParams.has(key)) url.searchParams.set(key, params[key]);
        });
        a.href = url.toString();
        a.dataset.utmDone = '';
    }

    document.querySelectorAll('a[href]').forEach(tag);
    // Catch links added later (e.g. "load more" posts) just before they're followed
    ['pointerdown', 'keydown'].forEach(function (type) {
        document.addEventListener(type, function (e) {
            const a = e.target.closest && e.target.closest('a[href]');
            if (a) tag(a);
        }, true);
    });
})();

/* Reading progress bar */
(function () {
    const bar = document.querySelector('.fa-progress span');
    const content = document.querySelector('.fa-content');
    if (!bar || !content) return;

    let ticking = false;
    function update() {
        const rect = content.getBoundingClientRect();
        const total = rect.height - window.innerHeight * 0.6;
        const read = Math.min(Math.max(-rect.top + window.innerHeight * 0.2, 0), total);
        bar.style.transform = `scaleX(${total > 0 ? read / total : 0})`;
        ticking = false;
    }
    window.addEventListener('scroll', function () {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    }, {passive: true});
    update();
})();

/* Table of contents built from the post's h2/h3 headings (Ghost gives them ids) */
(function () {
    const toc = document.querySelector('.fa-toc');
    const tocMobile = document.querySelector('.fa-toc-mobile');
    if (!toc) return;

    const headings = Array.from(document.querySelectorAll('.fa-content > h2[id], .fa-content > h3[id]'));
    if (headings.length < 3) return;

    [toc, tocMobile].forEach(function (container) {
        if (!container) return;
        const list = container.querySelector('.fa-toc-list');
        headings.forEach(function (h) {
            const li = document.createElement('li');
            li.className = h.tagName === 'H3' ? 'is-sub' : '';
            const a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent;
            li.appendChild(a);
            list.appendChild(li);
        });
        container.hidden = false;
    });

    if (tocMobile) {
        tocMobile.addEventListener('click', function (e) {
            if (e.target.closest('a')) tocMobile.open = false;
        });
    }

    const links = toc.querySelectorAll('a');
    function setActive(id) {
        links.forEach(function (a) {
            a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
        });
    }

    const observer = new IntersectionObserver(function (entries) {
        const visible = entries.filter(function (e) { return e.isIntersecting; });
        if (visible.length) setActive(visible[0].target.id);
    }, {rootMargin: '0px 0px -70% 0px'});
    headings.forEach(function (h) { observer.observe(h); });
})();

/* Copy link buttons */
(function () {
    document.querySelectorAll('[data-copy-url]').forEach(function (button) {
        button.addEventListener('click', function () {
            const label = button.querySelector('span') || button;
            const original = label.textContent;
            navigator.clipboard.writeText(button.dataset.copyUrl).then(function () {
                label.textContent = 'Copied';
                button.classList.add('is-done');
                setTimeout(function () {
                    label.textContent = original;
                    button.classList.remove('is-done');
                }, 1800);
            });
        });
    });
})();

/* Number feed rows so page 2+ continues counting (01, 02 … 13, 14) */
(function () {
    const feed = document.querySelector('.fa-feed');
    if (!feed) return;
    let offset = parseInt(feed.dataset.offset || '0', 10);
    if (feed.dataset.page && feed.dataset.perPage) {
        offset = (parseInt(feed.dataset.page, 10) - 1) * parseInt(feed.dataset.perPage, 10);
    }
    feed.style.counterReset = `post ${offset}`;
})();

/* Lightbox for gallery and feature images */
(function () {
    lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image');
})();

/* Responsive video embeds */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* "Load more" button pagination */
(function () {
    if (document.querySelector('.gh-loadmore')) pagination(false);
})();

/* Scrollable wrapper for wide tables */
(function () {
    document.querySelectorAll('.gh-content > table:not(.gist table)').forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
